module.exports = __webpack_public_path__ + "/login_ui/img/er-bbb6f8856605d9a436382ca84e87b17d.svg";